/* RESPONSIBLE TEAM: team-workflows */
import type HandoffToExternalAgent from 'embercom/models/operator/visual-builder/step/handoff-to-external-agent';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToExternalAgentConfiguration extends StepConfig {
  declare step: HandoffToExternalAgent;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-external-agent',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
